export let DATE_INPUT_SUPPORTED = false
try {
  const test = document.createElement('input')
  test.type = 'date'
  DATE_INPUT_SUPPORTED = test.type !== 'text'
} catch (e) {
  console.warn('input[type=date] not supported in this browser, using fallback')
}
